import { render, staticRenderFns } from "./DexsPartial.htm?vue&type=template&id=1d91584a&scoped=true&external"
import script from "./DexsPartial.js?vue&type=script&lang=js&external"
export * from "./DexsPartial.js?vue&type=script&lang=js&external"
import style0 from "./DexsPartial.scss?vue&type=style&index=0&id=1d91584a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d91584a",
  null
  
)

export default component.exports